'use client';

import { ReactNode } from 'react';
import { useInView } from '@/hooks/useInView';

interface LazyLoadWrapperProps {
  children: ReactNode;
  threshold?: number;
  rootMargin?: string;
  className?: string;
}

export const LazyLoadWrapper = ({
  children,
  threshold = 0.1,
  rootMargin = '100px',
  className = '',
}: LazyLoadWrapperProps) => {
  const { ref, isInView } = useInView({
    threshold,
    rootMargin,
  });

  return (
    <div ref={ref as React.RefObject<HTMLDivElement>} className={className}>
      {isInView ? children : null}
    </div>
  );
};
